// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"3e4c1510","774":"79456e22","787":"8723f909"}[chunkId] + ".chunk.js";
};